import {useEffect} from 'react';
import {useRecoilValue} from 'recoil';
import {authState} from '../../../store/auth/atoms';
import {usePostCompaniesFindByIdsQuery} from '../../../global/services/companies';
import {CurrentUserAndCompanyBalance, SetLoading} from '../types/balance-payment.types';

export const useCurrentUserAndCompanyBalance = (setLoading: SetLoading): CurrentUserAndCompanyBalance => {
  const {user} = useRecoilValue(authState);
  const companyIds = user?.companyId ? [user.companyId] : [];
  const {data, loading} = usePostCompaniesFindByIdsQuery(companyIds);
  const company = data?.[0] ?? null;

  useEffect(() => {
    setLoading?.(loading);
  }, [loading, setLoading]);

  return {user, data: company};
};
